import React from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { ErrorView } from '../../error/ErrorView'
import { useAppTranslation } from '../../../hooks/useAppTranslation'
import { IllustrationChoices } from '../../../components/common/Illustration'
import { ButtonVariant } from '../../../components/common/Button'
import { reverseUrl } from '../../../navigation/reverseUrl'
import { theme } from '../../../theme/theme'
import { useDocumentTitle } from '../../../hooks/useDocumentTitle'
import { reverseDocumentTitle } from '../../../navigation/reverseDocumentTitle'

export const GettingStartedCompletedView = (): React.ReactNode => {
  const { translate } = useAppTranslation()
  const { id } = useParams<{ id: string }>()
  const navigate = useNavigate()
  useDocumentTitle(reverseDocumentTitle('management:getting-started-completed'))
  return (
    <ErrorView
      className="text-center"
      title={translate('gettingStartedCompletedScreen.title')}
      subtitle={translate('gettingStartedCompletedScreen.description')}
      illustration={IllustrationChoices.CHECKLIST}
      buttons={[
        {
          id: 'getting-started-completed-view-continue-button',
          button: {
            label: translate('gettingStartedCompletedScreen.button'),
            variant: ButtonVariant.PRIMARY,
            onClick: () => {
              navigate(reverseUrl('society', { id }))
            },
          },
        },
      ]}
      custom={
        <p style={{ ...theme.textVariants.base }} className="mt-8 container">
          {translate('gettingStartedCompletedScreen.restartGuide')}
        </p>
      }
    />
  )
}
